import axios from "axios";
import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";
import SonicTaxonomy from "../../../common/classes/SonicTaxonomy";

/**
 * getTaxonomies
 *
 * Fetches taxonomy data.
 *
 * @returns An array of taxonomies.
 */

export const getTaxonomies = async () => {
  try {
    const response = await axios.get(getAPIRoot(APIRoutes.get.taxonomy));

    const data = response.data.message;

    const tax: Array<SonicTaxonomy> = [];

    data.forEach((e: any) => {
      const taxonomy = SonicTaxonomy.parseFromAPIResponse(e);
      tax.push(taxonomy);
    });

    return tax;
  } catch (e) {
    return null;
  }
};
